// extracted by mini-css-extract-plugin
export default {"UnlikedPath":"CommentViewIcon_UnlikedPath__ny8Gm","LikedPath":"CommentViewIcon_LikedPath__ODEce"};